import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { DataTable } from 'components//DataTable'
import { selection } from '../../../tableColumns'
import Divider from 'components/Divider'
import get from 'helpers/get'

const TableSets = ({ data = [], onSelect, onDelSet }) => {
	const [t] = useTranslation()

	const tableData = data.map(row => {
		const { minQuantity = '-', maxQuantity = '-', fixProducts = [] } = row
		const rowData = { minQuantity, maxQuantity, fixProduct: [], amount: [], price: [] }
		fixProducts.forEach(({ code, name, amount, price }) => {
			rowData.fixProduct.push(`${code || ''} - ${name || ''}`)
			rowData.amount.push(`${amount || '-'}`)
			rowData.price.push(`${price || '-'}`)
		})
		const categoryName = get(['category', 'name'], row)
		const id = get(['category', 'id'], row)
		return {
			setInd: row.setInd,
			id,
			...rowData,
			categoryName
		}
	})

	const handleDelSet = categoryId => {
		const set = tableData.find(({ id }) => Number(id) === Number(categoryId)) || {}
		onDelSet(set.setInd)
	}

	return(
		<Fragment>
			<Row>
				<Col xs={12}>
					<DataTable
						data={tableData}
						columns={selection}
						label={t('product_section.strings.set_products')}
						withSearch
						selectRow
						onRowClick={(state, { original }) => onSelect(original.setInd)}
						mutateRow={{ onRowMutate: handleDelSet }}
						style={{ height: 'auto' }}
						minRows={0}
						onAddRecord={() => onSelect(-1)}
					/>
				</Col>
			</Row>
			<Divider height={20}/>
		</Fragment>
	)
}

TableSets.propTypes = {
	data: PropTypes.array,
	onSelect: PropTypes.func.isRequired,
	onDelSet: PropTypes.func.isRequired
}

export default TableSets
